import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import TablePagination from '@material-ui/core/TablePagination';
import { LoadingComponent } from '../../../../utils/newLoader';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const screenCode = 'EMPLOYEEBREAKDETAILSREPORT';

export default function EmployeeBreakDetailsReport(props) {
  const [title] = useState("Employee Break Details Report");
  const classes = useStyles();
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [breakDetail, setBreakDetail] = useState({
    groupID: 0,
    factoryID: 0,
    employeeNumber: '',
    date: new Date().toISOString().substring(0, 10),
    employeeTypeID: 0
  });
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [breakData, setBreakData] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: 0,
    factoryID: 0,
    employeeTypeID: 0

  })
  const [EmployeeTypeList] = useState({
    0: '--Select Employee Type--',
    1: 'Registered',
    2: 'Contract'
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const [csvHeaders] = useState([])
  const componentRef = useRef();

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [breakDetail.groupID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'EMPLOYEEBREAKDETAILSREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setBreakDetail({
      ...breakDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(breakDetail.groupID);
    setFactoryList(factories);
  }

  function getSelectedDropdownValuesForReport(model) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[model.GroupID],
      factoryName: FactoryList[model.FactoryID],
      registrationNumber: model.RegistrationNumber || '',
      date: model.Date,
      employeeTypeID: model.EmployeeTypeID,
      employeeTypeName: getEmployeeTypeName(model.EmployeeTypeID)
    })
  }

  async function GetDetails() {
    const model = {
      GroupID: parseInt(breakDetail.groupID),
      FactoryID: parseInt(breakDetail.factoryID),
      Date: breakDetail.date,
      EmployeeTypeID: parseInt(breakDetail.employeeTypeID),
      RegistrationNumber: breakDetail.employeeNumber == " " ? null : breakDetail.employeeNumber
    };
    getSelectedDropdownValuesForReport(model);

    const employeeBreakData = await services.GetEmployeeBreakDetails(model);
    if (employeeBreakData.statusCode == "Success" && employeeBreakData.data != null) {
      employeeBreakData.data.sort((a, b) => {
        const regA = a.registrationNumber || '';
        const regB = b.registrationNumber || '';
        return regA.localeCompare(regB, undefined, { numeric: true, sensitivity: 'base' });
      });
      createDataForExcel(employeeBreakData.data);
      if (employeeBreakData.data.length == 0) {
        alert.error("No records to display");
      }
    } else {
      alert.error(employeeBreakData.message);
    }
    setBreakData(employeeBreakData.data);
  }

  function getEmployeeTypeName(employeeTypeID) {
    const typeMap = {
      0: 'All',
      1: 'Registered',
      2: 'Contract'
    };
    return typeMap[employeeTypeID] || 'Unknown';
  }

  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.map(x => {
        var vr = {
          'Registration Number': x.registrationNumber,
          'Employee Name': x.employeeName,
          'Employee Type': x.employeeTypeName,
          'In Time': x.inTime,
          'Break Type': x.employeeIntervalTypeName,
          'Start Time': x.startTime,
          'End Time': (() => {
            if (!x.endTime || x.endTime === 'null') {
              return 'Pending...';
            }
            return x.endTime;
          })(),
          'Time Duration': (() => {
            if (!x.endTime || x.endTime === '00:00:00' || x.endTime === 'null') {
              return 'Pending...';
            }
            if (!x.startTime) return '-';
            const start = moment(x.startTime, 'YYYY-MM-DD hh:mm:ss a');
            let end = moment(x.endTime, 'YYYY-MM-DD hh:mm:ss a');
            if (!start.isValid() || !end.isValid()) return '-';
            if (end.isBefore(start)) {
              end.add(1, 'day');
            }
            const duration = moment.duration(end.diff(start));
            if (duration.asSeconds() <= 0) return '-';
            const days = Math.floor(duration.asDays());
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();
            return `${days}d ${hours}h ${minutes}m ${seconds}s`;
          })(),
        }
        res.push(vr);
      });
      res.push({});

      var vr = {
        'Registration Number': 'Group: ' + GroupList[breakDetail.groupID],
        'Employee Name': 'Factory: ' + FactoryList[breakDetail.factoryID],
      }
      res.push(vr);

      var vr = {
        'Employee Registration Number': 'Date: ' + breakDetail.date,
        'Employee Type': 'Employee Type: ' + getEmployeeTypeName(breakDetail.employeeTypeID),
        'Employee Registration Number': breakDetail.employeeNumber ? 'Reg No: ' + breakDetail.employeeNumber : 'All Employees'
      }
      res.push(vr);
    }
    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(breakData);
    var settings = {
      sheetName: 'Employee Break Report',
      fileName: "Employee Break Details Report - " + GroupList[breakDetail.groupID] + ' ' + FactoryList[breakDetail.factoryID] + ' ' + breakDetail.date,
      writeOptions: {}
    }
    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })
    let dataA = [
      {
        sheet: '',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  function getEmployeeTypeName(employeeTypeID) {
    const typeMap = {
      0: 'All',
      1: 'Registered',
      2: 'Contract'
    };
    return typeMap[employeeTypeID] || 'Unknown';
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function isEmptyValue(value) {
    return value === null || value === undefined || value === '';
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    if (target.name === "groupID") {
      setBreakDetail({
        ...breakDetail,
        [e.target.name]: value,
        factoryID: 0
      });
    } else if (target.name === "factoryID") {
      setBreakDetail({
        ...breakDetail,
        [e.target.name]: value,
        employeeTypeID: 0,
        employeeNumber: ""
      });
    } else if (target.name === "date") {
      setBreakDetail({
        ...breakDetail,
        [e.target.name]: value,
        employeeTypeID: 0,
        employeeNumber: ""
      });
    } else {

      setBreakDetail({
        ...breakDetail,
        [e.target.name]: value
      });
      setBreakData([]);
      setPage(0);
    }
  }

  function handleDateTime(dateTime) {
    const dateTtime = new Date(dateTime);
    const date = dateTtime.toLocaleDateString('en-CA');
    const time = dateTtime.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
    return (
      <>
        {date}
        <br />
        <strong>{time}</strong>
      </>
    );
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
        }
   
        body {
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: breakDetail.groupID,
              factoryID: breakDetail.factoryID,
              date: breakDetail.date,
              employeeTypeID: breakDetail.employeeTypeID,
              employeeNumber: breakDetail.employeeNumber
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                date: Yup.string().required('Select a date'),
              })
            }
            onSubmit={() => trackPromise(GetDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              size='small'
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={breakDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size='small'
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={breakDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="date">
                              Date *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.date && errors.date)}
                              fullWidth
                              helperText={touched.date && errors.date}
                              size='small'
                              name="date"
                              type="date"
                              onChange={(e) => handleChange(e)}
                              value={breakDetail.date}
                              variant="outlined"
                              id="date"
                            />
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="employeeTypeID">
                              Employee Type
                            </InputLabel>
                            <TextField select
                              fullWidth
                              size='small'
                              name="employeeTypeID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={breakDetail.employeeTypeID}
                              variant="outlined"
                              id="employeeTypeID"
                            >
                              {generateDropDownMenu(EmployeeTypeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="employeeNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              size='small'
                              fullWidth
                              name="employeeNumber"
                              onChange={(e) => handleChange(e)}
                              value={breakDetail.employeeNumber}
                              variant="outlined"
                              id="employeeNumber"
                            >
                            </TextField>
                          </Grid>
                          <Grid container justify="flex-end">
                            <Box pr={2}>
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                              >
                                Search
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </CardContent>
                      <br />
                      <br />
                      <Divider />
                      <Box minWidth={1050} style={{ paddingRight: '10px', paddingLeft: '10px' }}>
                        {breakData.length > 0 ?
                          <TableContainer>
                            <Table aria-label="caption table">
                              <TableHead>
                                <TableRow style={{ border: "2px solid black" }}>
                                  <TableCell align={'center'} style={{ border: "2px solid black", fontWeight: "bold" }}>Registration Number</TableCell>
                                  <TableCell align={'center'} style={{ border: "2px solid black", fontWeight: "bold" }}>Employee Name</TableCell>
                                  <TableCell align={'center'} style={{ border: "2px solid black", fontWeight: "bold" }}>Employee Type</TableCell>
                                  <TableCell align={'center'} style={{ border: "2px solid black", fontWeight: "bold" }}>In Time</TableCell>
                                  <TableCell align={'center'} style={{ border: "2px solid black", fontWeight: "bold" }}>Break Type</TableCell>
                                  <TableCell align={'center'} style={{ border: "2px solid black", fontWeight: "bold" }}>Start Time</TableCell>
                                  <TableCell align={'center'} style={{ border: "2px solid black", fontWeight: "bold" }}>End Time</TableCell>
                                  <TableCell align={'center'} style={{ border: "2px solid black", fontWeight: "bold" }}>Time Duration</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {Object.entries(
                                  breakData
                                    .slice(page * limit, page * limit + limit)
                                    .reduce((acc, data) => {
                                      const regNum = data.registrationNumber || '-';
                                      if (!acc[regNum]) acc[regNum] = [];
                                      acc[regNum].push(data);
                                      return acc;
                                    }, {})
                                ).map(([registrationNumber, employees]) => (
                                  <React.Fragment key={registrationNumber}>
                                    {employees.map((data, index) => (
                                      <TableRow key={`${registrationNumber}-${index}`} style={{ border: "2px solid black" }}>
                                        {index === 0 && (
                                          <TableCell
                                            justifyContent={"center"}
                                            align={'left'}
                                            component="th"
                                            scope="row"
                                            ststyle={{
                                              border: "2px solid black",
                                              verticalAlign: 'middle',
                                              textAlign: 'center'
                                            }}
                                            className={isEmptyValue(data.registrationNumber) ? classes.emptyCell : ''}
                                            rowSpan={employees.length}
                                          >
                                            {registrationNumber}
                                          </TableCell>
                                        )}
                                        <TableCell align={'left'} component="th" scope="row" style={{ border: "2px solid black" }} className={isEmptyValue(data.employeeName) ? classes.emptyCell : ''}>
                                          {data.employeeName || '-'}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ border: "2px solid black" }} className={isEmptyValue(data.employeeType) ? classes.emptyCell : ''}>
                                          {data.employeeTypeName || '-'}
                                        </TableCell>
                                        <TableCell align={'center'} component="th" scope="row" style={{ border: "2px solid black" }} className={isEmptyValue(data.inTime) ? classes.emptyCell : ''}>
                                          {data.inTime ? handleDateTime(data.inTime) : '-'}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ border: "2px solid black" }} className={isEmptyValue(data.breakType) ? classes.emptyCell : ''}>
                                          {data.employeeIntervalTypeName || '-'}
                                        </TableCell>
                                        <TableCell align={'center'} component="th" scope="row" style={{ border: "2px solid black" }} className={isEmptyValue(data.startTime) ? classes.emptyCell : ''}>
                                          {data.startTime ? handleDateTime(data.startTime) : '-'}
                                        </TableCell>
                                        <TableCell
                                          align={'center'}
                                          component="th"
                                          scope="row"
                                          style={{ border: "2px solid black" }}
                                          className={isEmptyValue(data.endTime) ? classes.emptyCell : ''}
                                        >
                                          {!data.endTime || data.endTime === 'null' || data.endTime === '00:00:00' ? <b style={{ color: "red" }}>Pending...</b> : handleDateTime(data.endTime)}
                                        </TableCell>
                                        <TableCell align={'center'} component="th" scope="row" style={{ border: "2px solid black" }}>
                                          {(() => {
                                            if (!data.endTime || data.endTime === '00:00:00' || data.endTime === 'null') {
                                              return <span style={{ color: 'red', fontWeight: 'bold' }}>Pending...</span>;
                                            }
                                            if (!data.startTime) return '-';
                                            const start = moment(data.startTime, 'YYYY-MM-DD hh:mm:ss a');
                                            let end = moment(data.endTime, 'YYYY-MM-DD hh:mm:ss a');

                                            if (!start.isValid() || !end.isValid()) return '-';

                                            if (end.isBefore(start)) {
                                              end.add(1, 'day');
                                            }
                                            const duration = moment.duration(end.diff(start));
                                            if (duration.asSeconds() <= 0) return '-';
                                            const days = Math.floor(duration.asDays());
                                            const hours = duration.hours();
                                            const minutes = duration.minutes();
                                            const seconds = duration.seconds();

                                            return `${days}d ${hours}h ${minutes}m ${seconds}s`;
                                          })()}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </React.Fragment>
                                ))}
                              </TableBody>
                            </Table>
                            <TablePagination
                              component="div"
                              count={breakData.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer> : null}
                      </Box>
                      {breakData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={"Employee Break Details Report - " + GroupList[breakDetail.groupID] + ' ' + FactoryList[breakDetail.factoryID] + ' ' + breakDetail.date}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                            >
                              PDF
                            </Button>}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              breakData={breakData}
                              searchData={selectedSearchValues}
                              breakDetail={breakDetail}
                              selectedSearchValues={{
                                ...selectedSearchValues,
                                groupName: GroupList[breakDetail.groupID],
                                factoryName: FactoryList[breakDetail.factoryID],
                                registrationNumber: breakDetail.employeeNumber || '',
                                date: breakDetail.date,
                                employeeTypeID: breakDetail.employeeTypeID,
                                employeeTypeName: getEmployeeTypeName(breakDetail.employeeTypeID)
                              }}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  )
}